import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import { classesCrudStateConfig } from "../../../../consts";

const classesMetaReducer = makeCrudStateReducer(classesCrudStateConfig);
export default classesMetaReducer;
